module.exports = "/assets/b04759b52de1b5f875317e393cfee0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2H.png
// module id = 983
// module chunks = 0